export enum AccordionSections {
  Description = 'description-section',
  Delivery = 'delivery-section',
  Reviews = 'reviews-section',
}

export const AccordionSectionTrackingMap = {
  [AccordionSections.Description]: 'Product Details',
  [AccordionSections.Delivery]: 'Delivery Options',
  [AccordionSections.Reviews]: 'Reviews',
}

export enum AccordionSectionActions {
  OPEN = 'open',
  CLOSE = 'close',
}
